import {MODALS, DELEGATION_STATES, SWITCHOPTIONS} from 'common/domain/constants';
import {MODULE_ID, DELEGATION_TYPE, AA_DELEGATIONS_MANAGER_MODAL_COACHMARK_CONFIG} from 'food-benefit.module/common/domain/constants';
import {formatDate} from 'common/utils/dateUtils/date-utils';

class FoodBenefitDelegationsController {
  constructor($window,
              $log,
              foodDelegationService,
              FoodBenefitUserDataService,
              HelperDelegationsService,
              loadingMobileService,
              metricsService) {
    'ngInject';
    this.log = $log;
    this.foodDelegationService = foodDelegationService;
    this.FoodBenefitUserDataService = FoodBenefitUserDataService;
    this.helperDelegations = HelperDelegationsService;
    this.loadingMobileService = loadingMobileService;
    this.metricsService = metricsService;

    this.isMobileApp = $window.innerWidth < 1024;
    this.loaded = false;
    this.moduleId = MODULE_ID;
    this.userId = this.FoodBenefitUserDataService.getEmployee().userId;
    this.employeeRole = this.FoodBenefitUserDataService.getEmployee()._profile.role();
    this.successTitle = 'GLOBALS.SUCCESS_DELEGATION';
    this.cancelDelegationSuccessTitle = 'GLOBALS.CANCEL_SUCCESS_DELEGATION';
    this.coachmarkData = AA_DELEGATIONS_MANAGER_MODAL_COACHMARK_CONFIG;
  }

  $onInit() {
    this.getDelegationsFromBack();
  }

  getDelegationsFromBack() {
    this.loadingMobileService.show();
    this.foodDelegationService.getDelegations(this.userId).then(delegations => {
      this.delegationsObject = delegations;
      this.helperDelegations.sendEventToChangeIconDelegations();
      this.loaded = true;
    }).finally(() => {
      this.loadingMobileService.hide();
    });
  }

  get modal() {
    return $(MODALS.DELEGATIONS_MANAGER);
  }

  openModal({action, delegation}) {
    this.modalState = action;
    this.selectedDelegation = delegation;
    this.modal.modal('show');
  }

  closeModal() {
    this.modalState = '';
    this.selectedDelegation = {};
    this.modal.modal('hide');
  }

  onDismiss() {
    this.closeModal();
  }

  sendCancelDelegation() {
    const objectToCancel = {
      startDate: this.selectedDelegation.startDate,
      employeeId: this.selectedDelegation.employeeId,
      service: MODULE_ID,
      type: this.selectedDelegation.type,
    };

    this.loadingMobileService.show();
    this.foodDelegationService.deleteDelegation(this.userId, objectToCancel).then(() => {
      this.modalState = DELEGATION_STATES.SUCCESS;
      this.modalTitle = this.cancelDelegationSuccessTitle;
      this.getDelegationsFromBack();
    }, (error) => {
      this.modalState = DELEGATION_STATES.ERROR;
      this.modalMessage = error.data.message;
      this.modalTitle = error.data.errors.codigo;
    }).finally(() => {
      this.loadingMobileService.hide();
    });
  }

  sendEditDelegation({startDate, endDate}) {
    startDate = formatDate(startDate);
    endDate = formatDate(endDate);

    const objectToSend = {
      startDate,
      endDate,
      id: this.selectedDelegation.id,
      type: this.selectedDelegation.type,
      service: MODULE_ID,
    };

    this.loadingMobileService.show();
    this.foodDelegationService.updateDelegation(this.userId, objectToSend).then(() => {
      this.modalState = DELEGATION_STATES.SUCCESS;
      this.modalTitle = this.successTitle;
      this.getDelegationsFromBack();
    }, (error) => {
      this.modalState = DELEGATION_STATES.ERROR;
      this.modalMessage = error.data.message;
      this.modalTitle = error.data.errors.codigo;
    }).finally(() => {
      this.loadingMobileService.hide();
    });
  }

  getTypeOfDelegation($event) {
    this.typeOfDelegation = $event.option;
    this.typeOfDelegation = this.typeOfDelegation === SWITCHOPTIONS.USER ? DELEGATION_TYPE.EMPLOYEE : DELEGATION_TYPE.MANAGER;
  }

  sendDelegation($event) {
    const startDate = formatDate($event.startDate);
    const endDate = formatDate($event.endDate);
    const employeeId = $event.employee;

    const delegationToCreate = {
      startDate,
      endDate,
      employeeId,
      service: MODULE_ID,
      type: this.typeOfDelegation || DELEGATION_TYPE.EMPLOYEE,
    };

    this.log.info({delegationToCreate});
    this.loadingMobileService.show();
    this.foodDelegationService.createDelegation(this.userId, delegationToCreate).then(() => {
      this.modalState = DELEGATION_STATES.SUCCESS;
      this.modalTitle = this.successTitle;
      this.getDelegationsFromBack();

      this.metricsService.trackFoodBenefitDelegation({delegationType: delegationToCreate.type});
    }, (error) => {
      this.modalState = DELEGATION_STATES.ERROR;
      this.modalMessage = error.data.message;
      this.modalTitle = error.data.errors.codigo;
    }).finally(() => {
      this.loadingMobileService.hide();
    });
  }
}

export default FoodBenefitDelegationsController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/features/foodBenefitDelegations/foodBenefitDelegations.controller.js